var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.loading
      ? _c("div", { staticClass: "loading" }, [
          _c(
            "div",
            { staticClass: "md-layout md-gutter md-alignment-top-center" },
            [
              _c("md-progress-spinner", {
                attrs: {
                  "md-diameter": 50,
                  "md-stroke": 5,
                  "md-mode": "indeterminate"
                }
              })
            ],
            1
          )
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.event
      ? _c(
          "div",
          { staticClass: "md-layout md-gutter md-alignment-top-center" },
          [
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-15 md-medium-size-10 md-small-size-10 md-xsmall-size-0"
              },
              [
                _c(
                  "md-button",
                  {
                    staticClass: "md-fab",
                    on: {
                      click: function($event) {
                        return _vm.goBack()
                      }
                    }
                  },
                  [_c("md-icon", [_vm._v("arrow_back")])],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "md-layout-item md-size-75 md-medium-size-70 md-small-size-100 md-xsmall-size-100"
              },
              [
                _c(
                  "md-card",
                  { staticStyle: { width: "100%" } },
                  [
                    _c("md-card-header", [
                      _c("div", { staticClass: "md-title" }, [
                        _vm._v(_vm._s(_vm.event.name))
                      ])
                    ]),
                    _vm._v(" "),
                    _c("md-card-content", [
                      _c("div", { staticClass: "md-layout md-gutter" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "md-layout-item md-size-90 md-medium-size-80 md-small-size-90 md-xsmall-size-100"
                          },
                          [
                            _c("p", {
                              domProps: {
                                innerHTML: _vm._s(_vm.event.description)
                              }
                            })
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-layout md-gutter md-alignment-center-left"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-30 md-medium-size-20 md-small-size-100 md-xsmall-size-100"
                            },
                            [
                              _vm.event.image != "undefined"
                                ? _c("img", {
                                    attrs: {
                                      "event.image": "",
                                      src: "" + _vm.event.imgLink
                                    }
                                  })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-70 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-alignment-top-left"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-50 md-medium-size-30 md-small-size-50 md-xsmall-size-100"
                                    },
                                    [
                                      _c("b", [_vm._v("Kategorie:")]),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(_vm.event.category)
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("b", [_vm._v("Termin:")]),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(_vm.event.eventdate)
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-50 md-medium-size-30 md-small-size-50 md-xsmall-size-100"
                                    },
                                    [
                                      _c("b", [_vm._v("Ort:")]),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(_vm.event.place)
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-layout md-gutter md-alignment-center-left"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-90 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-50 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                                    },
                                    [
                                      _c("b", [_vm._v("Links:")]),
                                      _vm._v(" "),
                                      _c("p", [
                                        _c("b", [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              attrs: { href: _vm.event.link }
                                            },
                                            [
                                              _vm._v(
                                                "Link zur Anmeldung über Mittelstand-Digital"
                                              )
                                            ]
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _vm._l(_vm.event.infoLinks, function(
                                        item
                                      ) {
                                        return _c("p", { key: item }, [
                                          _c(
                                            "a",
                                            {
                                              staticStyle: {
                                                cursor: "pointer"
                                              },
                                              attrs: { href: item }
                                            },
                                            [_vm._v(_vm._s(item))]
                                          )
                                        ])
                                      })
                                    ],
                                    2
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-50 md-medium-size-33 md-small-size-50 md-xsmall-size-100"
                                    },
                                    [
                                      _c("b", [_vm._v("Tags")]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "md-layout md-gutter md-alignment-top-center"
                                        },
                                        _vm._l(_vm.event.tags, function(tag) {
                                          return _c(
                                            "div",
                                            {
                                              key: tag,
                                              staticClass: "md-layout-item"
                                            },
                                            [
                                              _c(
                                                "md-chip",
                                                {
                                                  staticClass: "md-secondary",
                                                  staticStyle: { margin: "2px" }
                                                },
                                                [_vm._v(_vm._s(tag))]
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        0
                                      )
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass:
                            "md-layout md-gutter md-alignment-center-left"
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "md-layout-item md-size-90 md-medium-size-80 md-small-size-100 md-xsmall-size-100"
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "md-layout md-gutter md-alignment-top-center"
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                    },
                                    [
                                      _c("b", [_vm._v("Ansprechpartner:")]),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.event.contactName
                                          )
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("p", {
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.event.contactEmail
                                          )
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("div", {
                                    staticClass:
                                      "md-layout-item md-size-50 md-medium-size-50 md-small-size-100 md-xsmall-size-100"
                                  })
                                ]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", {
              staticClass:
                "md-layout-item md-size-10 md-medium-size-20 md-small-size-20 md-xsmall-size-40"
            })
          ]
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d81223fe", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d81223fe","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/search/eventsearch/detail/EventDetail.vue
// module id = null
// module chunks = 